<template>
  <div>
    <el-tabs class="common-el-tabs" type="card">
      <el-tab-pane label="单个、批量">
        <comp-club class="common-el-tab-flex" />
      </el-tab-pane>
      <el-tab-pane label="全局">
        <div style="position: relative; min-height: 250px">
          <el-form class="form" ref="ruleForm" label-width="150px" :model="form" :rules="rules">
            <el-form-item label="AT状态(德州)：">
              <el-switch
                v-model="form.statusOfAuto"
                active-value="on"
                inactive-value="off"
                active-text="开启"
                inactive-text="关闭"
              />
            </el-form-item>
            <el-form-item label="AT状态(AOF)：">
              <el-switch
                v-model="form.aofStatusOfAuto"
                active-value="on"
                inactive-value="off"
                active-text="开启"
                inactive-text="关闭"
              />
            </el-form-item>
            <el-form-item label="爆牌状态(德州)：">
              <el-switch
                v-model="form.statusOfET"
                active-value="on"
                inactive-value="off"
                active-text="开启"
                inactive-text="关闭"
              />
            </el-form-item>
            <el-form-item label="爆牌状态(AOF)：">
              <el-switch
                v-model="form.aofStatusOfET"
                active-value="on"
                inactive-value="off"
                active-text="开启"
                inactive-text="关闭"
              />
            </el-form-item>
            <el-form-item label="手机号：" prop="mobile">
              <el-input v-model="form.mobile" placeholder="请输入">
                <el-select style="width: 100px" v-model="form.countryCode" slot="prepend">
                  <el-option
                    v-for="item of mobileCountryCodeOptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="谷歌验证码：" prop="code">
              <el-input v-model="form.code" placeholder="请输入"> </el-input>
            </el-form-item>
            <div class="footer">
              <el-button type="primary" @click="submitForm('ruleForm')">设置</el-button>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="MT">
        <comp-mt />
      </el-tab-pane>
      <el-tab-pane label="在线玩家">
        <comp-online-player class="common-el-tab-flex" />
      </el-tab-pane>
      <el-tab-pane label="爆桌模式">
        <comp-blast-card class="common-el-tab-flex" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { mobileCountryCodeOptions } from 'mixins';
import compClub from './compClub';
import compMt from './compMT';
import compOnlinePlayer from './compOnlinePlayer';
import compBlastCard from './compBlastCard';

export default {
  mixins: [mobileCountryCodeOptions],
  components: {
    compClub,
    compMt,
    compOnlinePlayer,
    compBlastCard,
  },
  data() {
    return {
      form: {
        statusOfAuto: 'off',
        statusOfET: 'off',
        aofStatusOfAuto: 'off',
        aofstatusOfET: 'off',
        mobile: '',
        countryCode: '86',
        code: '',
      },
      rules: {
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    ...mapActions('other', ['sendCode']),
    ...mapActions('at', ['getATDetail', 'atSwitchApply']),
    getDetail() {
      this.getATDetail().then((res) => {
        this.form = Object.assign({}, this.form, {
          statusOfAuto: res.data.statusOfAuto,
          statusOfET: res.data.statusOfET,
          aofStatusOfAuto: res.data.aofStatusOfAuto,
          aofStatusOfET: res.data.aofStatusOfET,
        });
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.atSwitchApply(this.form).then(() => {
            this.$message.success('设置成功');
            this.close(formName);
            this.getDetail();
          });
        }
      });
    },
    close(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.form {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 500px;
  @media (min-height: 590px) {
    top: 15%;
  }
  :global(.el-select) {
    width: 100%;
  }
}

.footer {
  padding: 15px 0 0 100px;
  text-align: center;
  :global(.el-button) {
    width: 150px;
  }
}

.common-scroll {
}
</style>
